import React from "react";
import AppInfo from "../../../components/desktop/app-info";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";

const AppLanding = () => {
    return (
        <div>
            <ErrorHandler>
                <Helmet>
                    <link href={`${appUrl()}/mobile-apps/`} rel="canonical" />
                    <meta name="description" content={"Sell your car with ease using the CARS24 mobile app. Get instant quotes, hassle-free paperwork, and quick payments all in one place."} />
                </Helmet>
                <AppInfo />
            </ErrorHandler>
        </div>
    );
};
export default withLayout(AppLanding);
